import React from 'react'
import styled from 'styled-components'
import TransitionLink from 'gatsby-plugin-transition-link'
import gsap from 'gsap'

const HeaderView = styled.div`
  display: none;
  position: fixed;
  top: 0;
  right: 3rem;
  height: 53px;
  padding: 10px 0;
  z-index: 100;
  width: 60%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: 768px) {
    display: flex;
  }
`

const Button = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
  color: ${({isIndex}) => isIndex ? '#ffffff' : '#000000'};
  cursor: pointer;
  a {
    ${({isIndex}) => isIndex ? '#ffffff' : '#000000'};
  }
`

const ArrowHolder = styled.div`
  display: inline-block;
  transition: transform .3s;
  width: 12px;
  height: 12px;
  line-height: 0;
  padding: 1px;
  margin-top: -2px;

  svg {
    height: 100%;
    width: 100%;
  }
`

const TextView = styled.span`
  margin-right: 8px;
  font-size: 0.75rem;
  font-family: 'Sica', sans-serif;

  @media screen and (min-width: 768px) {
    font-weight: 400;
  }
`

const Arrow = ({ isIndex }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14.981" height="14.981" viewBox="0 0 14.981 14.981">
    <g id="Arrow" transform="translate(-1263.186 -14.5)">
      <path id="Path_986" data-name="Path 986" d="M390-215h14.127v14.127" transform="translate(873.539 230)" fill="none" stroke={isIndex ? '#ffffff' : '#000000'}  strokeMiterlimit="10" strokeWidth="1"/>
      <line id="Line_12" data-name="Line 12" x1="13.833" y2="13.833" transform="translate(1263.539 15.295)" fill="none" stroke={isIndex ? '#ffffff' : '#000000'} strokeMiterlimit="10" strokeWidth="1"/>
    </g>
  </svg>
)

const Header = ({ toggleSavedEventsMenu, isIndex, toggleFullProgram }) => {
  return (
    <HeaderView>
      <TransitionLink
        to="/signup"
        exit={{
          trigger: ({ entry, node }) => gsap.to(node, { opacity: 0, duration: .3 }),
          length: .3
        }}
        entry={{
          trigger: ({ exit, node }) => gsap.from(node, { opacity: 0, duration: .3 }),
          delay: .3,
          length: .3
        }}
      >
        <Button isIndex={isIndex} >
          <TextView>SIGN UP</TextView>
          <ArrowHolder >
            <Arrow isIndex={isIndex}/>
          </ArrowHolder>
        </Button>
      </TransitionLink>

      <TransitionLink
        to="/information"
        exit={{
          trigger: ({ entry, node }) => gsap.to(node, { opacity: 0, duration: .3 }),
          length: .3
        }}
        entry={{
          trigger: ({ exit, node }) => gsap.from(node, { opacity: 0, duration: .3 }),
          delay: .3,
          length: .3
        }}
      >
        <Button isIndex={isIndex} >
          <TextView>INFORMATION</TextView>
          <ArrowHolder >
            <Arrow isIndex={isIndex}/>
          </ArrowHolder>
        </Button>
      </TransitionLink>

      <Button onClick={() => toggleSavedEventsMenu(true)} isIndex={isIndex} >
        <TextView>SAVED TOURS</TextView>
        <ArrowHolder >
          <Arrow isIndex={isIndex}/>
        </ArrowHolder>
      </Button>

      <Button isIndex={isIndex} onClick={toggleFullProgram}>
        <TextView>FULL PROGRAM</TextView>
        <ArrowHolder>
          <Arrow isIndex={isIndex}/>
        </ArrowHolder>
      </Button>
    </HeaderView>
  )
}

export default Header
